import React, { useEffect, useState } from "react";
import { connectStore } from "redux-box";
import { module as wordsinfo } from "@st/wordsinfo";
import { module as ui } from "@st/ui";
import { id } from "@g/GlobalModal";
import useDebouncing from "@u/useDebouncing";
import "../SpeakingFeaturesView.css";

const PAGE_SIZE = 20;

function WordsInfoContainer({ wordsinfo, ui, search = "" }) {
  const [currentOffset, setCurrentOffset] = useState(0);

  const debouncedSearch = useDebouncing(search, 400);

  useEffect(() => {
    wordsinfo.requestWords(0, debouncedSearch || "", "");
    setCurrentOffset(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  const handlePrev = () => {
    const prev = wordsinfo.pagination ? wordsinfo.pagination.prev_page : 0;
    wordsinfo.requestWords(prev, debouncedSearch || "", "");
    setCurrentOffset(prev);
  };

  const handleNext = () => {
    const next = wordsinfo.pagination ? wordsinfo.pagination.next_page : 0;
    wordsinfo.requestWords(next, debouncedSearch || "", "");
    setCurrentOffset(next);
  };

  const openAddModal = () => {
    window.wordsInfoEditData = null;
    ui.showModal(id.WORDSINFO_FORM_MODAL);
  };

  const handleEdit = (word) => {
    window.wordsInfoEditData = word;
    ui.showModal(id.WORDSINFO_FORM_MODAL);
  };

  const handleDelete = (wordId) => {
    if (window.confirm("Delete this word?")) {
      wordsinfo.deleteWord(wordId);
    }
  };

  const playAudio = (url) => {
    if (window.sfActiveAudio) {
      window.sfActiveAudio.pause();
    }
    const audio = new Audio(url);
    audio.play().catch((err) => console.error("Audio playback failed:", err));
    window.sfActiveAudio = audio;
  };

  const pagination = wordsinfo.pagination;
  const hasPrev = pagination && currentOffset > 0;
  const hasNext = pagination && pagination.has_next;
  const totalCount = pagination ? pagination.count : 0;
  const dynamicPageSize = (pagination && pagination.page_size) || 25;
  const pageStart = totalCount === 0 ? 0 : currentOffset * dynamicPageSize + 1;
  const pageEnd = totalCount === 0 ? 0 : pageStart + (wordsinfo.words ? wordsinfo.words.length : 0) - 1;

  return (
    <div className="sf-inner">
      {/* ── Table (only this scrolls) ── */}
      {wordsinfo.isLoading ? (
        <div className="sf-loading">Loading…</div>
      ) : (
        <div className="sf-table-wrapper">
          <table className="sf-table">
            <thead>
              <tr>
                <th>Word</th>
                <th>Themes</th>
                <th>Usable In</th>
                <th>Voice Over</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {wordsinfo.words.length === 0 ? (
                <tr>
                  <td colSpan="5" className="sf-empty">No words found.</td>
                </tr>
              ) : (
                wordsinfo.words.map((w) => (
                  <tr key={w.id}>
                    <td>
                      <strong>{w.word || "--"}</strong>
                    </td>
                    <td>{w.themes || "--"}</td>
                    <td>
                      <div style={{ fontSize: "12px", color: "#555" }}>
                        {w.word_game && <div>✓ Word Game</div>}
                        {w.pictionary && <div>✓ Pictionary</div>}
                        {w.phonetic && <div>✓ Phonetic</div>}
                      </div>
                    </td>
                    <td>
                      {w.voice_over ? (
                        <button
                          className="sf-audio-btn"
                          onClick={() => playAudio(w.voice_over)}
                        >
                          ▶ Play
                        </button>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>
                      <button className="sf-action-btn" onClick={() => handleEdit(w)}>
                        Edit
                      </button>
                      <button
                        className="sf-action-btn sf-action-btn--delete"
                        onClick={() => handleDelete(w.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ── Pagination ── */}
      {!wordsinfo.isLoading && totalCount > 0 && (
        <div className="sf-pagination">
          <span className="sf-pagination__info">
            {pageStart}–{pageEnd} of {totalCount}
          </span>
          <button className="sf-pagination__btn" onClick={handlePrev} disabled={!hasPrev}>
            ← Prev
          </button>
          <button className="sf-pagination__btn" onClick={handleNext} disabled={!hasNext}>
            Next →
          </button>
        </div>
      )}

      {/* ── FAB ── */}
      <button id="wi-add-fab" className="sf-fab" title="Add Word Info" onClick={openAddModal}>
        +
      </button>
    </div>
  );
}

export default connectStore({ wordsinfo, ui })(WordsInfoContainer);
